import { FC } from "react";
import KickImage from 'Reuseables/KickImage';

//Interface
import { DateCardInterface } from "../definitions";

const DateCard: FC<DateCardInterface> = ({
  scheduledList,
  selectedDate,
  setSelectedDate
}) => {
  if (!scheduledList?.length) return null;

  return (
    <>
      <p className="scheduled-title">Set Drop-off Time</p>
      <div className="scheduled-card-wrapper">
        {
          scheduledList.map((card, index) => {
            const selected = `${selectedDate?.day}${selectedDate?.month}${selectedDate?.date}${selectedDate?.year}` === `${card?.day}${card?.month}${card?.date}${card?.year}`;
            return (
              <div key={index} className={`date-card ${selected ? "active" : ""}`} onClick={() => setSelectedDate(card)}>
                <p>{card?.day}, {card?.month}, <span className="date">{card?.date}<span className="suffix">{card?.suffix}</span></span></p>
              </div>
            )
          })
        }
      </div>
    </>
  )
}

export default DateCard;